export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	shakite: {
		learnset: {
			agility: ["9M"],
			bide: ["7V"],
			charge: ["9M", "9L1", "7L1", "6L1", "5L1", "4L1", "3L1"],
			chargebeam: ["9M", "9L16", "7M", "7L16", "6M", "6L16", "5M", "5L22", "4M", "4L26"],
			confide: ["7M", "6M"],
			curse: ["9M", "7V"],
			discharge: ["9L41", "7L41", "6L41"],
			doubleedge: ["9M"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			eerieimpulse: ["9M", "9L1", "7L1", "6L6"],
			electricterrain: ["9M"],
			electroball: ["9M", "9L22", "7L22", "6L22", "5L29"],
			electroweb: ["9M"],
			endure: ["9M", "7V", "4M", "3T"],
			explosion: ["9L47", "8V", "7M", "7L47", "7V", "6M", "6L47", "5M", "5L57", "4M", "4L51", "3T", "3L54"],
			facade: ["9M", "8V", "7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			foulplay: ["9M", "8V", "7T", "6T", "5T"],
			frustration: ["7M", "7V", "6M", "5M", "4M", "3M"],
			gigaimpact: ["9M", "7M", "6M", "5M", "4M"],
			gyroball: ["9M", "9L54", "7M", "7L54", "6M", "6L51", "5M", "5L51", "4M", "4L46"],
			headbutt: ["8V", "7V", "4T"],
			helpinghand: ["9M"],
			hiddenpower: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hyperbeam: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3M"],
			lightscreen: ["9M", "9L29", "8V", "7M", "7L29", "7V", "6M", "6L26", "5M", "5L26", "4M", "4L22", "3M", "3L41"],
			magiccoat: ["7T", "6T", "5T", "4T"],
			magneticflux: ["9L1", "7L1", "6L1"],
			magnetrise: ["9L36", "7T", "7L36", "6T", "6L36", "5T", "5L46", "4T", "4L40"],
			metalsound: ["9M"],
			mimic: ["7V", "3T"],
			mirrorcoat: ["9L58", "8V", "7L58", "7V", "6L58", "5L62", "4L57", "3L59"],
			naturalgift: ["4M"],
			protect: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["9M", "7M", "7V", "6M", "5M", "4M", "3M"],
			reflect: ["8V", "7V"],
			rest: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rollout: ["9L11", "7L11", "7V", "6L11", "5L15", "4T", "4L15", "3T", "3L34"],
			round: ["7M", "6M", "5M"],
			scaryface: ["9M"],
			screech: ["9L13", "8V", "7L13", "7V", "6L13", "5L19", "4L19", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["9L26", "8V", "7L26", "7V", "6L26", "5L35", "4L29", "3T", "3L27"],
			shockwave: ["7T", "6T", "4M", "3M"],
			signalbeam: ["7T", "6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["9M", "7M", "7V", "6M", "5T", "4M", "3T"],
			snore: ["7T", "7V", "6T", "5T", "4T", "3T"],
			sonicboom: ["8V", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			spark: ["9L9", "7L9", "6L1", "5L1", "4L1", "3L21"],
			substitute: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supercellslam: ["9M"],
			swagger: ["7M", "7V", "6M", "5M", "4M", "3T"],
			swift: ["9M", "9L20", "8V", "7L20", "7V", "6L20", "5L40", "4T", "4L35", "3T", "3L48"],
			tackle: ["9L1", "8V", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["9M", "7V"],
			taunt: ["9M", "8V", "7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["7T"],
			teleport: ["8V", "7V"],
			terablast: ["9M"],
			thief: ["9M", "7M", "6M", "5M", "4M", "3M"],
			thunder: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3M"],
			thundershock: ["9L1", "8V"],
			thunderwave: ["9M", "8V", "7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["8V", "7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["9M", "7M", "6M", "5M"],
			wildcharge: ["9M", "7M", "6M", "5M"],
			zapcannon: ["7V"],
		},
		encounters: [
			{generation: 1, level: 3},
			{generation: 2, level: 23},
			{generation: 3, level: 3, nature: "Hasty", ivs: {hp: 19, atk: 16, def: 18, spa: 25, spd: 25, spe: 19}, abilities: ["static"], pokeball: "pokeball"},
			{generation: 4, level: 23},
		],
	},
	ogerponpixiedust: {
		eventOnly: true,
	},
  // advent mons
 	strobite: {
		learnset: {
			bite: ["9L1"],
			bodyslam: ["9L1"],
			camouflage: ["9L1"],
			charge: ["9L1"],
			confide: ["9L1"],
			crunch: ["9L1"],
			darkpulse: ["9L1"],
			discharge: ["9L1"],
			doubleedge: ["9L1"],
			electricterrain: ["9L1"],
			electroball: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			falseswipe: ["9L1"],
			firefang: ["9L1"],
			flamethrower: ["9L1"],
			fling: ["9L1"],
			gigaimpact: ["9L1"],
			helpinghand: ["9L1"],
			hyperbeam: ["9L1"],
			ironhead: ["9L1"],
			leer: ["9L1"],
			mudslap: ["9L1"],
			protect: ["9L1"],
			psychicfangs: ["9L1"],
			quickguard: ["9L1"],
			rapidspin: ["9L1"],
			rest: ["9L1"],
			risingvoltage: ["9L1"],
			scaryface: ["9L1"],
			shockwave: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			snore: ["9L1"],
			spark: ["9L1"],
			spikes: ["9L1"],
			substitute: ["9L1"],
			supercellslam: ["9L1"],
			swift: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			temperflare: ["9L1"],
			terablast: ["9L1"],
			thunder: ["9L1"],
			thunderfang: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			thundershock: ["9L1"],
			toxic: ["9L1"],
			voltswitch: ["9L1"],
			workup: ["9L1"],
			zingzap: ["9L1"],
			volttackle: ["9L1"],
		},
	},
	xurkitreesinnoh: {
		learnset: {
			bestow: ["9L1"],
			branchpoke: ["9L1"],
			charm: ["9L1"],
			decorate: ["9L1"],
			fairywind: ["9L1"],
			glitzyglow: ["9L1"],
			grassknot: ["9L1"],
			leafstorm: ["9L1"],
			moonlight: ["9L1"],
			powdersnow: ["9L1"],
			snowscape: ["9L1"],
			trailblaze: ["9L1"],
			triattack: ["9L1"],
			wrap: ["9L1"],
		},
	},
	sandta: {
		learnset: {
			acidarmor: ["9L1"],
			ancientpower: ["9L1"],
			aquaring: ["9L1"],
			bestow: ["9L1"],
			bodypress: ["9L1"],
			bodyslam: ["9L1"],
			brine: ["9L1"],
			bulldoze: ["9L1"],
			charm: ["9L1"],
			chillingwater: ["9L1"],
			clearsmog: ["9L1"],
			dig: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			encore: ["9L1"],
			harden: ["9L1"],
			icebeam: ["9L1"],
			icepunch: ["9L1"],
			icywind: ["9L1"],
			liquidation: ["9L1"],
			milkdrink: ["9L1"],
			mist: ["9L1"],
			mudbomb: ["9L1"],
			mudshot: ["9L1"],
			mudslap: ["9L1"],
			playnice: ["9L1"],
			present: ["9L1"],
			protect: ["9L1"],
			rest: ["9L1"],
			rocktomb: ["9L1"],
			sandattack: ["9L1"],
			sandtomb: ["9L1"],
			sandstorm: ["9L1"],
			scald: ["9L1"],
			scorchingsands: ["9L1"],
			shoreup: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			soak: ["9L1"],
			substitute: ["9L1"],
			surf: ["9L1"],
			terablast: ["9L1"],
			tickle: ["9L1"],
			tidalgift: ["9L1"],
			waterpulse: ["9L1"],
			wavecrash: ["9L1"],
		},
	},
	eiscuesnowcone: {
		learnset: {
			airslash: ["9L1"],
			aquajet: ["9L1"],
			bravebird: ["9L1"],
			bubble: ["9L1"],
			bubblebeam: ["9L1"],
			calmmind: ["9L1"],
			esperwing: ["9L1"],
			freezingglare: ["9L1"],
			gust: ["9L1"],
			iciclestorm: ["9L1"],
			kinesis: ["9L1"],
			lightscreen: ["9L1"],
			mirrorcoat: ["9L1"],
			psychic: ["9L1"],
			psychicterrain: ["9L1"],
			psyshock: ["9L1"],
			tripleaxel: ["9L1"],
			wingattack: ["9L1"],
		},
	},
	cardemelli: {
		learnset: {
			alluringvoice: ["9L1"],
			ancientpower: ["9L1"],
			aromatherapy: ["9L1"],
			aromaticmist: ["9L1"],
			attract: ["9L1"],
			bodypress: ["9L1"],
			bulldoze: ["9L1"],
			calmmind: ["9L1"],
			captivate: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			craftyshield: ["9L1"],
			dazzlinggleam: ["9L1"],
			decorate: ["9L1"],
			defensecurl: ["9L1"],
			dig: ["9L1"],
			disarmingvoice: ["9L1"],
			entrainment: ["9L1"],
			fairywind: ["9L1"],
			followme: ["9L1"],
			gigadrain: ["9L1"],
			harden: ["9L1"],
			haze: ["9L1"],
			healpulse: ["9L1"],
			healingwish: ["9L1"],
			hypervoice: ["9L1"],
			lightscreen: ["9L1"],
			mistyterrain: ["9L1"],
			mudbomb: ["9L1"],
			mudshot: ["9L1"],
			mudslap: ["9L1"],
			mudsport: ["9L1"],
			muddywater: ["9L1"],
			mysticalfire: ["9L1"],
			playnice: ["9L1"],
			playrough: ["9L1"],
			pollenpuff: ["9L1"],
			pound: ["9L1"],
			powergem: ["9L1"],
			purify: ["9L1"],
			raindance: ["9L1"],
			recover: ["9L1"],
			reflect: ["9L1"],
			safeguard: ["9L1"],
			sandattack: ["9L1"],
			sandtomb: ["9L1"],
			sandstorm: ["9L1"],
			scorchingsands: ["9L1"],
			soak: ["9L1"],
			spikes: ["9L1"],
			strangesteam: ["9L1"],
			surf: ["9L1"],
			sweetkiss: ["9L1"],
			sweetscent: ["9L1"],
			syrupbomb: ["9L1"],
			watergun: ["9L1"],
			waterpulse: ["9L1"],
			weatherball: ["9L1"],
			wideguard: ["9L1"],
			wish: ["9L1"],
			withdraw: ["9L1"],
			yawn: ["9L1"],
		},
	},
	gingertar: {
		learnset: {
			aerialace: ["9L1"],
			ancientpower: ["9L1"],
			aquatail: ["9L1"],
			assurance: ["9L1"],
			attract: ["9L1"],
			avalanche: ["9L1"],
			bite: ["9L1"],
			blizzard: ["9L1"],
			block: ["9L1"],
			bodypress: ["9L1"],
			bodyslam: ["9L1"],
			breakingswipe: ["9L1"],
			brickbreak: ["9L1"],
			brutalswing: ["9L1"],
			bulldoze: ["9L1"],
			captivate: ["9L1"],
			chipaway: ["9L1"],
			confide: ["9L1"],
			counter: ["9L1"],
			crunch: ["9L1"],
			curse: ["9L1"],
			cut: ["9L1"],
			darkpulse: ["9L1"],
			detect: ["9L1"],
			dig: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			dragonbreath: ["9L1"],
			dragonclaw: ["9L1"],
			dragondance: ["9L1"],
			dragonpulse: ["9L1"],
			dragontail: ["9L1"],
			dynamicpunch: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			fireblast: ["9L1"],
			firefang: ["9L1"],
			firepunch: ["9L1"],
			flamecharge: ["9L1"],
			flamethrower: ["9L1"],
			flareblitz: ["9L1"],
			fling: ["9L1"],
			focusblast: ["9L1"],
			focusenergy: ["9L1"],
			focuspunch: ["9L1"],
			foulplay: ["9L1"],
			frustration: ["9L1"],
			furycutter: ["9L1"],
			gigaimpact: ["9L1"],
			gingerstorm: ["9L1"],
			hardpress: ["9L1"],
			headbutt: ["9L1"],
			heatwave: ["9L1"],
			heavyslam: ["9L1"],
			helpinghand: ["9L1"],
			hiddenpower: ["9L1"],
			highhorsepower: ["9L1"],
			honeclaws: ["9L1"],
			hydropump: ["9L1"],
			hyperbeam: ["9L1"],
			icebeam: ["9L1"],
			icefang: ["9L1"],
			icepunch: ["9L1"],
			icywind: ["9L1"],
			incinerate: ["9L1"],
			inferno: ["9L1"],
			irondefense: ["9L1"],
			ironhead: ["9L1"],
			irontail: ["9L1"],
			knockoff: ["9L1"],
			lashout: ["9L1"],
			leer: ["9L1"],
			lowkick: ["9L1"],
			megakick: ["9L1"],
			megapunch: ["9L1"],
			mimic: ["9L1"],
			mudshot: ["9L1"],
			mudslap: ["9L1"],
			muddywater: ["9L1"],
			naturalgift: ["9L1"],
			nightmare: ["9L1"],
			outrage: ["9L1"],
			payback: ["9L1"],
			powergem: ["9L1"],
			poweruppunch: ["9L1"],
			protect: ["9L1"],
			pursuit: ["9L1"],
			ragingfury: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			retaliate: ["9L1"],
			return: ["9L1"],
			revenge: ["9L1"],
			roar: ["9L1"],
			rockblast: ["9L1"],
			rockpolish: ["9L1"],
			rockslide: ["9L1"],
			rocksmash: ["9L1"],
			rockthrow: ["9L1"],
			rocktomb: ["9L1"],
			round: ["9L1"],
			sandtomb: ["9L1"],
			sandstorm: ["9L1"],
			scaryface: ["9L1"],
			screech: ["9L1"],
			secretpower: ["9L1"],
			seismictoss: ["9L1"],
			shadowclaw: ["9L1"],
			shockwave: ["9L1"],
			sleeptalk: ["9L1"],
			smackdown: ["9L1"],
			snarl: ["9L1"],
			snore: ["9L1"],
			spicyextract: ["9L1"],
			spite: ["9L1"],
			stealthrock: ["9L1"],
			stomp: ["9L1"],
			stompingtantrum: ["9L1"],
			stoneedge: ["9L1"],
			strength: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			superpower: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			terablast: ["9L1"],
			thrash: ["9L1"],
			thunder: ["9L1"],
			thunderfang: ["9L1"],
			thunderpunch: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			torment: ["9L1"],
			toxic: ["9L1"],
			uproar: ["9L1"],
			waterpulse: ["9L1"],
			whirlpool: ["9L1"],
			willowisp: ["9L1"],
		},
	},
	nuzcracker: {
		learnset: {
			absorb: ["9L1"],
			aircutter: ["9L1"],
			airslash: ["9L1"],
			amnesia: ["9L1"],
			assurance: ["9L1"],
			astonish: ["9L1"],
			attract: ["9L1"],
			beatup: ["9L1"],
			bide: ["9L1"],
			bodyslam: ["9L1"],
			brickbreak: ["9L1"],
			bulkup: ["9L1"],
			bulletseed: ["9L1"],
			captivate: ["9L1"],
			chillingwater: ["9L1"],
			closecombat: ["9L1"],
			coaching: ["9L1"],
			confide: ["9L1"],
			curse: ["9L1"],
			cut: ["9L1"],
			darkpulse: ["9L1"],
			defensecurl: ["9L1"],
			defog: ["9L1"],
			dig: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			drainpunch: ["9L1"],
			embargo: ["9L1"],
			endeavor: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			explosion: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			fakeout: ["9L1"],
			falseswipe: ["9L1"],
			feintattack: ["9L1"],
			flash: ["9L1"],
			fling: ["9L1"],
			focusblast: ["9L1"],
			foulplay: ["9L1"],
			frustration: ["9L1"],
			furycutter: ["9L1"],
			gigadrain: ["9L1"],
			grassknot: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			growth: ["9L1"],
			harden: ["9L1"],
			headbutt: ["9L1"],
			hiddenpower: ["9L1"],
			hyperbeam: ["9L1"],
			knockoff: ["9L1"],
			leafblade: ["9L1"],
			leafstorm: ["9L1"],
			leechseed: ["9L1"],
			lowkick: ["9L1"],
			lowsweep: ["9L1"],
			magicalleaf: ["9L1"],
			megadrain: ["9L1"],
			megakick: ["9L1"],
			mimic: ["9L1"],
			mudslap: ["9L1"],
			naturalgift: ["9L1"],
			naturepower: ["9L1"],
			nightslash: ["9L1"],
			payback: ["9L1"],
			poisonjab: ["9L1"],
			poisonsting: ["9L1"],
			pound: ["9L1"],
			powerswap: ["9L1"],
			poweruppunch: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			quickattack: ["9L1"],
			raindance: ["9L1"],
			razorleaf: ["9L1"],
			razorwind: ["9L1"],
			refresh: ["9L1"],
			rest: ["9L1"],
			retaliate: ["9L1"],
			return: ["9L1"],
			rockslide: ["9L1"],
			rocksmash: ["9L1"],
			rocktomb: ["9L1"],
			rollout: ["9L1"],
			round: ["9L1"],
			sacredsword: ["9L1"],
			scaryface: ["9L1"],
			secretpower: ["9L1"],
			seedbomb: ["9L1"],
			selfdestruct: ["9L1"],
			shadowball: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			solarblade: ["9L1"],
			spite: ["9L1"],
			strength: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			swift: ["9L1"],
			swordsdance: ["9L1"],
			synthesis: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			toxic: ["9L1"],
			trailblaze: ["9L1"],
			twineedle: ["9L1"],
			upperhand: ["9L1"],
			uproar: ["9L1"],
			weatherball: ["9L1"],
			worryseed: ["9L1"],
			xscissor: ["9L1"],
		},
	},
	smorgasbag: {
		learnset: {
			acid: ["9L1"],
			acidspray: ["9L1"],
			belch: ["9L1"],
			bodyslam: ["9L1"],
			bulletseed: ["9L1"],
			chillyreception: ["9L1"],
			christmascannon: ["9L1"],
			clearsmog: ["9L1"],
			corrosivegas: ["9L1"],
			decorate: ["9L1"],
			frustration: ["9L1"],
			gastroacid: ["9L1"],
			gigaimpact: ["9L1"],
			grasswhistle: ["9L1"],
			gunkshot: ["9L1"],
			haze: ["9L1"],
			hyperbeam: ["9L1"],
			iciclespear: ["9L1"],
			leafstorm: ["9L1"],
			metronome: ["9L1"],
			pinmissile: ["9L1"],
			poisongas: ["9L1"],
			present: ["9L1"],
			razorwind: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			selfdestruct: ["9L1"],
			sleeptalk: ["9L1"],
			sludge: ["9L1"],
			sludgebomb: ["9L1"],
			sludgewave: ["9L1"],
			spikes: ["9L1"],
			spitup: ["9L1"],
			stockpile: ["9L1"],
			strangesteam: ["9L1"],
			swallow: ["9L1"],
			teeterdance: ["9L1"],
			terablast: ["9L1"],
			toxic: ["9L1"],
			toxicspikes: ["9L1"],
			woodhammer: ["9L1"],
		},
	},
	sableyefestive: {
		learnset: {
			aerialace: ["9L1"],
			allyswitch: ["9L1"],
			astonish: ["9L1"],
			attract: ["9L1"],
			blizzard: ["9L1"],
			bodyslam: ["9L1"],
			brickbreak: ["9L1"],
			brutalswing: ["9L1"],
			bulkup: ["9L1"],
			calmmind: ["9L1"],
			captivate: ["9L1"],
			confide: ["9L1"],
			confuseray: ["9L1"],
			counter: ["9L1"],
			cut: ["9L1"],
			darkpulse: ["9L1"],
			dazzlinggleam: ["9L1"],
			detect: ["9L1"],
			dig: ["9L1"],
			disable: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			drainpunch: ["9L1"],
			dreameater: ["9L1"],
			dynamicpunch: ["9L1"],
			embargo: ["9L1"],
			encore: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			fakeout: ["9L1"],
			feint: ["9L1"],
			feintattack: ["9L1"],
			flash: ["9L1"],
			flatter: ["9L1"],
			fling: ["9L1"],
			focuspunch: ["9L1"],
			foresight: ["9L1"],
			foulplay: ["9L1"],
			frustration: ["9L1"],
			furycutter: ["9L1"],
			furyswipes: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			gravity: ["9L1"],
			gyroball: ["9L1"],
			headbutt: ["9L1"],
			helpinghand: ["9L1"],
			hex: ["9L1"],
			hiddenpower: ["9L1"],
			honeclaws: ["9L1"],
			hyperbeam: ["9L1"],
			icebeam: ["9L1"],
			icepunch: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			incinerate: ["9L1"],
			knockoff: ["9L1"],
			lashout: ["9L1"],
			leechseed: ["9L1"],
			leer: ["9L1"],
			lightscreen: ["9L1"],
			lowkick: ["9L1"],
			lowsweep: ["9L1"],
			magiccoat: ["9L1"],
			meanlook: ["9L1"],
			megakick: ["9L1"],
			megapunch: ["9L1"],
			metalburst: ["9L1"],
			metalclaw: ["9L1"],
			metronome: ["9L1"],
			mimic: ["9L1"],
			moonlight: ["9L1"],
			mudshot: ["9L1"],
			mudslap: ["9L1"],
			nastyplot: ["9L1"],
			naturalgift: ["9L1"],
			nightshade: ["9L1"],
			nightmare: ["9L1"],
			octazooka: ["9L1"],
			ominouswind: ["9L1"],
			painsplit: ["9L1"],
			payback: ["9L1"],
			phantomforce: ["9L1"],
			playrough: ["9L1"],
			poisonjab: ["9L1"],
			poltergeist: ["9L1"],
			powergem: ["9L1"],
			poweruppunch: ["9L1"],
			present: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			punishment: ["9L1"],
			quash: ["9L1"],
			raindance: ["9L1"],
			recover: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			retaliate: ["9L1"],
			return: ["9L1"],
			rocksmash: ["9L1"],
			rocktomb: ["9L1"],
			roleplay: ["9L1"],
			round: ["9L1"],
			scratch: ["9L1"],
			secretpower: ["9L1"],
			seismictoss: ["9L1"],
			shadowball: ["9L1"],
			shadowclaw: ["9L1"],
			shadowsneak: ["9L1"],
			shockwave: ["9L1"],
			signalbeam: ["9L1"],
			skillswap: ["9L1"],
			skittersmack: ["9L1"],
			sleeptalk: ["9L1"],
			snarl: ["9L1"],
			snatch: ["9L1"],
			snore: ["9L1"],
			snowscape: ["9L1"],
			solarbeam: ["9L1"],
			spite: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			telekinesis: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			throatchop: ["9L1"],
			thunderpunch: ["9L1"],
			thunderwave: ["9L1"],
			tickle: ["9L1"],
			torment: ["9L1"],
			toxic: ["9L1"],
			trick: ["9L1"],
			uturn: ["9L1"],
			waterpulse: ["9L1"],
			wonderroom: ["9L1"],
			woodhammer: ["9L1"],
			xscissor: ["9L1"],
		},
	},
	mariahcarey: {
		learnset: {
			attract: ["9L1"],
			auroraveil: ["9L1"],
			avalanche: ["9L1"],
			bodyslam: ["9L1"],
			brickbreak: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			copycat: ["9L1"],
			counter: ["9L1"],
			covet: ["9L1"],
			curse: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			drainpunch: ["9L1"],
			drainingkiss: ["9L1"],
			dynamicpunch: ["9L1"],
			echoedvoice: ["9L1"],
			encore: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			fakeout: ["9L1"],
			faketears: ["9L1"],
			fling: ["9L1"],
			focusblast: ["9L1"],
			focuspunch: ["9L1"],
			frostbreath: ["9L1"],
			gigaimpact: ["9L1"],
			grassknot: ["9L1"],
			hail: ["9L1"],
			headbutt: ["9L1"],
			healbell: ["9L1"],
			helpinghand: ["9L1"],
			hyperbeam: ["9L1"],
			hypervoice: ["9L1"],
			icebeam: ["9L1"],
			icepunch: ["9L1"],
			iciclespear: ["9L1"],
			icywind: ["9L1"],
			lick: ["9L1"],
			meanlook: ["9L1"],
			megakick: ["9L1"],
			megapunch: ["9L1"],
			metronome: ["9L1"],
			mimic: ["9L1"],
			mudslap: ["9L1"],
			overdrive: ["9L1"],
			partingshot: ["9L1"],
			payback: ["9L1"],
			perishsong: ["9L1"],
			pound: ["9L1"],
			powdersnow: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			psychicnoise: ["9L1"],
			recycle: ["9L1"],
			round: ["9L1"],
			screech: ["9L1"],
			seismictoss: ["9L1"],
			shadowball: ["9L1"],
			sing: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			sparklingaria: ["9L1"],
			substitute: ["9L1"],
			swagger: ["9L1"],
			sweetkiss: ["9L1"],
			sweetscent: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			thief: ["9L1"],
			thrash: ["9L1"],
			torment: ["9L1"],
			tripleaxel: ["9L1"],
			uproar: ["9L1"],
			wish: ["9L1"],
		},
	},
	draydol: {
		learnset: {
			allyswitch: ["9L1"],
			ancientpower: ["9L1"],
			bodypress: ["9L1"],
			bulldoze: ["9L1"],
			calmmind: ["9L1"],
			chargebeam: ["9L1"],
			confide: ["9L1"],
			confusion: ["9L1"],
			cosmicpower: ["9L1"],
			dazzlinggleam: ["9L1"],
			dig: ["9L1"],
			doubleteam: ["9L1"],
			doubleedge: ["9L1"],
			dreameater: ["9L1"],
			drillrun: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			eerieimpulse: ["9L1"],
			endure: ["9L1"],
			expandingforce: ["9L1"],
			explosion: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			futuresight: ["9L1"],
			gigaimpact: ["9L1"],
			grassknot: ["9L1"],
			gravity: ["9L1"],
			guardsplit: ["9L1"],
			guardswap: ["9L1"],
			gyroball: ["9L1"],
			harden: ["9L1"],
			headbutt: ["9L1"],
			hex: ["9L1"],
			hyperbeam: ["9L1"],
			icebeam: ["9L1"],
			imprison: ["9L1"],
			irondefense: ["9L1"],
			lightscreen: ["9L1"],
			magiccoat: ["9L1"],
			meteorbeam: ["9L1"],
			mimic: ["9L1"],
			miracledrill: ["9L1"],
			mudslap: ["9L1"],
			nastyplot: ["9L1"],
			powergem: ["9L1"],
			powersplit: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			psychicterrain: ["9L1"],
			psyshock: ["9L1"],
			raindance: ["9L1"],
			rapidspin: ["9L1"],
			recycle: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			rockblast: ["9L1"],
			rockpolish: ["9L1"],
			rockslide: ["9L1"],
			rocksmash: ["9L1"],
			rocktomb: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			sandtomb: ["9L1"],
			sandstorm: ["9L1"],
			scorchingsands: ["9L1"],
			selfdestruct: ["9L1"],
			shadowball: ["9L1"],
			skillswap: ["9L1"],
			sleeptalk: ["9L1"],
			smackdown: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			stealthrock: ["9L1"],
			stoneedge: ["9L1"],
			storedpower: ["9L1"],
			strength: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			swordsdance: ["9L1"],
			teleport: ["9L1"],
			toxic: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			tripleaxel: ["9L1"],
			wonderroom: ["9L1"],
			zenheadbutt: ["9L1"],
		},
	},
	gamesi: {
		learnset: {
			agility: ["9L1"],
			assurance: ["9L1"],
			attract: ["9L1"],
			bite: ["9L1"],
			brutalswing: ["9L1"],
			bulkup: ["9L1"],
			calmmind: ["9L1"],
			charge: ["9L1"],
			chargebeam: ["9L1"],
			darkpulse: ["9L1"],
			darkestlariat: ["9L1"],
			drainpunch: ["9L1"],
			electricterrain: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			flatter: ["9L1"],
			fling: ["9L1"],
			focusenergy: ["9L1"],
			gigaimpact: ["9L1"],
			helpinghand: ["9L1"],
			hyperbeam: ["9L1"],
			knockoff: ["9L1"],
			lashout: ["9L1"],
			leer: ["9L1"],
			megakick: ["9L1"],
			payback: ["9L1"],
			poisonjab: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			quash: ["9L1"],
			rest: ["9L1"],
			risingvoltage: ["9L1"],
			scaryface: ["9L1"],
			slackoff: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			snarl: ["9L1"],
			snore: ["9L1"],
			snowscape: ["9L1"],
			spark: ["9L1"],
			spite: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			swagger: ["9L1"],
			swift: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			throatchop: ["9L1"],
			thunder: ["9L1"],
			thundershock: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			thunderclap: ["9L1"],
			torment: ["9L1"],
			uproar: ["9L1"],
			volttackle: ["9L1"],
			weatherball: ["9L1"],
			wildcharge: ["9L1"],
			workup: ["9L1"],
		},
	},
	vipux: {
		learnset: {
			aquatail: ["9L1"],
			bite: ["9L1"],
			breakingswipe: ["9L1"],
			calmmind: ["9L1"],
			coil: ["9L1"],
			covet: ["9L1"],
			crunch: ["9L1"],
			disable: ["9L1"],
			dragondance: ["9L1"],
			dragonhammer: ["9L1"],
			dragonpulse: ["9L1"],
			dragonrush: ["9L1"],
			earthquake: ["9L1"],
			encore: ["9L1"],
			facade: ["9L1"],
			fireblast: ["9L1"],
			firefang: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			glare: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			haze: ["9L1"],
			hex: ["9L1"],
			hyperfang: ["9L1"],
			icefang: ["9L1"],
			infestation: ["9L1"],
			irontail: ["9L1"],
			jawlock: ["9L1"],
			knockoff: ["9L1"],
			leafstorm: ["9L1"],
			leechseed: ["9L1"],
			makeitrain: ["9L1"],
			moneytrees: ["9L1"],
			nastyplot: ["9L1"],
			outrage: ["9L1"],
			payday: ["9L1"],
			petalblizzard: ["9L1"],
			poisonfang: ["9L1"],
			protect: ["9L1"],
			psychicfangs: ["9L1"],
			rest: ["9L1"],
			scaleshot: ["9L1"],
			seedbomb: ["9L1"],
			sleeptalk: ["9L1"],
			snarl: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			sunnyday: ["9L1"],
			switcheroo: ["9L1"],
			synthesis: ["9L1"],
			tailslap: ["9L1"],
			tailwhip: ["9L1"],
			taunt: ["9L1"],
			thunderfang: ["9L1"],
			thunderwave: ["9L1"],
			toxic: ["9L1"],
			toxicspikes: ["9L1"],
			trailblaze: ["9L1"],
			weatherball: ["9L1"],
			willowisp: ["9L1"],
			yawn: ["9L1"],
		},
	},
	popsicelf: {
		learnset: {
			aerialace: ["9L1"],
			agility: ["9L1"],
			alluringvoice: ["9L1"],
			attract: ["9L1"],
			avalanche: ["9L1"],
			blizzard: ["9L1"],
			bulkup: ["9L1"],
			burningjealousy: ["9L1"],
			dazzlinggleam: ["9L1"],
			drainpunch: ["9L1"],
			ember: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			fireblast: ["9L1"],
			firepunch: ["9L1"],
			firespin: ["9L1"],
			flamewheel: ["9L1"],
			flamethrower: ["9L1"],
			flareblitz: ["9L1"],
			fling: ["9L1"],
			focusenergy: ["9L1"],
			gigaimpact: ["9L1"],
			grassknot: ["9L1"],
			heatwave: ["9L1"],
			helpinghand: ["9L1"],
			hyperbeam: ["9L1"],
			icebeam: ["9L1"],
			icepunch: ["9L1"],
			iceshard: ["9L1"],
			icespinner: ["9L1"],
			incinerate: ["9L1"],
			leer: ["9L1"],
			liquidation: ["9L1"],
			megakick: ["9L1"],
			overheat: ["9L1"],
			payback: ["9L1"],
			powdersnow: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			quickattack: ["9L1"],
			rest: ["9L1"],
			rockslide: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			snowscape: ["9L1"],
			solarbeam: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			taunt: ["9L1"],
			temperflare: ["9L1"],
			terablast: ["9L1"],
			tripleaxel: ["9L1"],
			uturn: ["9L1"],
			uproar: ["9L1"],
			weatherball: ["9L1"],
			willowisp: ["9L1"],
			workup: ["9L1"],
			zenheadbutt: ["9L1"],
		},
	},
	bellbeque: {
		learnset: {
			alluringvoice: ["9L1"],
			autotomize: ["9L1"],
			block: ["9L1"],
			bodyslam: ["9L1"],
			burnup: ["9L1"],
			flamecharge: ["9L1"],
			flamethrower: ["9L1"],
			flashcannon: ["9L1"],
			gyroball: ["9L1"],
			healbell: ["9L1"],
			heatcrash: ["9L1"],
			heavyslam: ["9L1"],
			irondefense: ["9L1"],
			ironhead: ["9L1"],
			perishsong: ["9L1"],
			torchsong: ["9L1"],
			voltswitch: ["9L1"],
			willowisp: ["9L1"],
			yawn: ["9L1"],
		},
	},
	chorislam: {
		learnset: {
			agility: ["9L1"],
			attract: ["9L1"],
			aurasphere: ["9L1"],
			bodypress: ["9L1"],
			bulkup: ["9L1"],
			charm: ["9L1"],
			closecombat: ["9L1"],
			confide: ["9L1"],
			covet: ["9L1"],
			defensecurl: ["9L1"],
			doubleedge: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			fling: ["9L1"],
			focusblast: ["9L1"],
			focusenergy: ["9L1"],
			foresight: ["9L1"],
			gigaimpact: ["9L1"],
			gunkshot: ["9L1"],
			highjumpkick: ["9L1"],
			hyperbeam: ["9L1"],
			hypervoice: ["9L1"],
			irondefense: ["9L1"],
			jumpkick: ["9L1"],
			knockoff: ["9L1"],
			leer: ["9L1"],
			megakick: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			shadowball: ["9L1"],
			slackoff: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			snore: ["9L1"],
			snowscape: ["9L1"],
			substitute: ["9L1"],
			swift: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			teeterdance: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			uturn: ["9L1"],
			uproar: ["9L1"],
			workup: ["9L1"],
		},
	},
	gholdengofestive: {
		learnset: {
			astonish: ["9L1"],
			cashout: ["9L1"],
			chargebeam: ["9L1"],
			confuseray: ["9L1"],
			dazzlinggleam: ["9L1"],
			electroball: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			flashcannon: ["9L1"],
			fling: ["9L1"],
			focusblast: ["9L1"],
			focuspunch: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			heavyslam: ["9L1"],
			hyperbeam: ["9L1"],
			leechseed: ["9L1"],
			lightscreen: ["9L1"],
			lowkick: ["9L1"],
			lowsweep: ["9L1"],
			magicalleaf: ["9L1"],
			makeitrain: ["9L1"],
			megadrain: ["9L1"],
			memento: ["9L1"],
			metalclaw: ["9L1"],
			metalsound: ["9L1"],
			nightshade: ["9L1"],
			poltergeist: ["9L1"],
			powergem: ["9L1"],
			protect: ["9L1"],
			psychic: ["9L1"],
			psyshock: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			sandstorm: ["9L1"],
			scratch: ["9L1"],
			shadowball: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			steelbeam: ["9L1"],
			synthesis: ["9L1"],
			takedown: ["9L1"],
			thief: ["9L1"],
			thunder: ["9L1"],
			thunderpunch: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			trick: ["9L1"],
		},
	},
	indeedeecook: {
		learnset: {
			alluringvoice: ["9L1"],
			allyswitch: ["9L1"],
			aromatherapy: ["9L1"],
			attract: ["9L1"],
			batonpass: ["9L1"],
			bodyslam: ["9L1"],
			burnup: ["9L1"],
			calmmind: ["9L1"],
			charm: ["9L1"],
			dazzlinggleam: ["9L1"],
			disarmingvoice: ["9L1"],
			drainpunch: ["9L1"],
			drainingkiss: ["9L1"],
			ember: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			expandingforce: ["9L1"],
			facade: ["9L1"],
			fakeout: ["9L1"],
			filletaway: ["9L1"],
			fireblast: ["9L1"],
			firespin: ["9L1"],
			flamecharge: ["9L1"],
			flamethrower: ["9L1"],
			followme: ["9L1"],
			futuresight: ["9L1"],
			guardsplit: ["9L1"],
			guardswap: ["9L1"],
			healpulse: ["9L1"],
			healingwish: ["9L1"],
			helpinghand: ["9L1"],
			hypervoice: ["9L1"],
			imprison: ["9L1"],
			incinerate: ["9L1"],
			lightscreen: ["9L1"],
			magicalleaf: ["9L1"],
			metronome: ["9L1"],
			mysticalfire: ["9L1"],
			overheat: ["9L1"],
			payday: ["9L1"],
			playnice: ["9L1"],
			playrough: ["9L1"],
			protect: ["9L1"],
			psybeam: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			psychicterrain: ["9L1"],
			psychoshift: ["9L1"],
			psyshock: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			shadowball: ["9L1"],
			skillswap: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			softboiled: ["9L1"],
			storedpower: ["9L1"],
			stuffcheeks: ["9L1"],
			substitute: ["9L1"],
			sweetscent: ["9L1"],
			swift: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			terrainpulse: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			willowisp: ["9L1"],
			zenheadbutt: ["9L1"],
		},
	},
	dulceirene: {
		learnset: {
			acidarmor: ["9L1"],
			alluringvoice: ["9L1"],
			aromatherapy: ["9L1"],
			aromaticmist: ["9L1"],
			attract: ["9L1"],
			babydolleyes: ["9L1"],
			calmmind: ["9L1"],
			celebrate: ["9L1"],
			charm: ["9L1"],
			dazzlinggleam: ["9L1"],
			decorate: ["9L1"],
			disarmingvoice: ["9L1"],
			drainpunch: ["9L1"],
			drainingkiss: ["9L1"],
			encore: ["9L1"],
			endeavor: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			entrainment: ["9L1"],
			facade: ["9L1"],
			faketears: ["9L1"],
			fling: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			haze: ["9L1"],
			healpulse: ["9L1"],
			helpinghand: ["9L1"],
			hyperbeam: ["9L1"],
			icebeam: ["9L1"],
			imprison: ["9L1"],
			lastresort: ["9L1"],
			lightscreen: ["9L1"],
			magicroom: ["9L1"],
			magicalleaf: ["9L1"],
			metronome: ["9L1"],
			mistyexplosion: ["9L1"],
			mistyterrain: ["9L1"],
			moonblast: ["9L1"],
			moonlight: ["9L1"],
			mysticalfire: ["9L1"],
			painsplit: ["9L1"],
			playrough: ["9L1"],
			pollenpuff: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			psyshock: ["9L1"],
			recover: ["9L1"],
			rest: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			storedpower: ["9L1"],
			substitute: ["9L1"],
			sweetkiss: ["9L1"],
			sweetscent: ["9L1"],
			tackle: ["9L1"],
			teleport: ["9L1"],
			terablast: ["9L1"],
			terrainpulse: ["9L1"],
			toxic: ["9L1"],
			triattack: ["9L1"],
			wish: ["9L1"],
			wonderroom: ["9L1"],
		},
	},
	wreith: {
		learnset: {
			decorate: ["9L1"],
			gigadrain: ["9L1"],
			haze: ["9L1"],
			healbell: ["9L1"],
			icebeam: ["9L1"],
			icywind: ["9L1"],
			leechseed: ["9L1"],
			mirrorcoat: ["9L1"],
			nastyplot: ["9L1"],
			painsplit: ["9L1"],
			poltergeist: ["9L1"],
			powerwhip: ["9L1"],
			rapidspin: ["9L1"],
			shadowball: ["9L1"],
			spikyshield: ["9L1"],
			synthesis: ["9L1"],
			trickroom: ["9L1"],
			willowisp: ["9L1"],
		},
	},
	eternalflowerwreith: {
		learnset: {
			acid: ["9L1"],
			acidspray: ["9L1"],
			bulletseed: ["9L1"],
			crosspoison: ["9L1"],
			dazzlinggleam: ["9L1"],
			decorate: ["9L1"],
			drainingkiss: ["9L1"],
			energyball: ["9L1"],
			fairywind: ["9L1"],
			floralhealing: ["9L1"],
			flowershield: ["9L1"],
			forestscurse: ["9L1"],
			gigadrain: ["9L1"],
			grassyterrain: ["9L1"],
			growth: ["9L1"],
			healbell: ["9L1"],
			hex: ["9L1"],
			icebeam: ["9L1"],
			icywind: ["9L1"],
			infestation: ["9L1"],
			ingrain: ["9L1"],
			leafblade: ["9L1"],
			leechseed: ["9L1"],
			lifedew: ["9L1"],
			lightofruin: ["9L1"],
			memento: ["9L1"],
			mirrorcoat: ["9L1"],
			mistyterrain: ["9L1"],
			nastyplot: ["9L1"],
			naturalgift: ["9L1"],
			naturepower: ["9L1"],
			painsplit: ["9L1"],
			petalblizzard: ["9L1"],
			petaldance: ["9L1"],
			poisonjab: ["9L1"],
			poisonpowder: ["9L1"],
			poisonsting: ["9L1"],
			pollenpuff: ["9L1"],
			powerwhip: ["9L1"],
			rapidspin: ["9L1"],
			razorleaf: ["9L1"],
			safeguard: ["9L1"],
			seedbomb: ["9L1"],
			shadowball: ["9L1"],
			sludge: ["9L1"],
			sludgebomb: ["9L1"],
			sludgewave: ["9L1"],
			smog: ["9L1"],
			solarbeam: ["9L1"],
			spiritbreak: ["9L1"],
			spikyshield: ["9L1"],
			stunspore: ["9L1"],
			sweetscent: ["9L1"],
			toxicspikes: ["9L1"],
			toxicthread: ["9L1"],
			trickroom: ["9L1"],
			venomdrench: ["9L1"],
			venoshock: ["9L1"],
			vinewhip: ["9L1"],
			worryseed: ["9L1"],
		},
	},
	clamperlalola: {
		learnset: {
			aquaring: ["9L1"],
			attract: ["9L1"],
			bodyslam: ["9L1"],
			brine: ["9L1"],
			confuseray: ["9L1"],
			doubleteam: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			flashcannon: ["9L1"],
			hail: ["9L1"],
			irondefense: ["9L1"],
			muddywater: ["9L1"],
			powergem: ["9L1"],
			protect: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			scald: ["9L1"],
			sleeptalk: ["9L1"],
			spikes: ["9L1"],
			stealthrock: ["9L1"],
			stoneedge: ["9L1"],
			substitute: ["9L1"],
			supersonic: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			watergun: ["9L1"],
			waterpulse: ["9L1"],
			waterfall: ["9L1"],
			whirlpool: ["9L1"],
		},
	},
	goodybyss: {
		learnset: {
			agility: ["9L1"],
			amnesia: ["9L1"],
			aquaring: ["9L1"],
			aquatail: ["9L1"],
			attract: ["9L1"],
			batonpass: ["9L1"],
			bodyslam: ["9L1"],
			breakingswipe: ["9L1"],
			brine: ["9L1"],
			coil: ["9L1"],
			confuseray: ["9L1"],
			confusion: ["9L1"],
			dive: ["9L1"],
			doubleteam: ["9L1"],
			dracometeor: ["9L1"],
			dragoncheer: ["9L1"],
			dragonclaw: ["9L1"],
			dragondance: ["9L1"],
			dragonpulse: ["9L1"],
			dragontail: ["9L1"],
			drainingkiss: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			flashcannon: ["9L1"],
			gigaimpact: ["9L1"],
			hail: ["9L1"],
			headsmash: ["9L1"],
			hydropump: ["9L1"],
			hyperbeam: ["9L1"],
			irondefense: ["9L1"],
			meteorbeam: ["9L1"],
			muddywater: ["9L1"],
			outrage: ["9L1"],
			powergem: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			roost: ["9L1"],
			safeguard: ["9L1"],
			scald: ["9L1"],
			shadowball: ["9L1"],
			sleeptalk: ["9L1"],
			spikes: ["9L1"],
			stealthrock: ["9L1"],
			stoneedge: ["9L1"],
			substitute: ["9L1"],
			supersonic: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			twister: ["9L1"],
			watergun: ["9L1"],
			waterpulse: ["9L1"],
			waterfall: ["9L1"],
			whirlpool: ["9L1"],
		},
	},
	naughtail: {
		learnset: {
			aquaring: ["9L1"],
			aquatail: ["9L1"],
			attract: ["9L1"],
			batonpass: ["9L1"],
			bite: ["9L1"],
			bodyslam: ["9L1"],
			brine: ["9L1"],
			coil: ["9L1"],
			confuseray: ["9L1"],
			crunch: ["9L1"],
			darkpulse: ["9L1"],
			dive: ["9L1"],
			doubleteam: ["9L1"],
			dragondance: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			flashcannon: ["9L1"],
			gigaimpact: ["9L1"],
			gunkshot: ["9L1"],
			hail: ["9L1"],
			headsmash: ["9L1"],
			hydropump: ["9L1"],
			hyperbeam: ["9L1"],
			icefang: ["9L1"],
			irondefense: ["9L1"],
			knockoff: ["9L1"],
			meteorbeam: ["9L1"],
			muddywater: ["9L1"],
			nastyplot: ["9L1"],
			powergem: ["9L1"],
			protect: ["9L1"],
			raindance: ["9L1"],
			rest: ["9L1"],
			rockslide: ["9L1"],
			rocktomb: ["9L1"],
			scald: ["9L1"],
			scaryface: ["9L1"],
			screech: ["9L1"],
			slackoff: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			smog: ["9L1"],
			snarl: ["9L1"],
			spikes: ["9L1"],
			stealthrock: ["9L1"],
			stoneedge: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			supersonic: ["9L1"],
			surf: ["9L1"],
			swagger: ["9L1"],
			toxic: ["9L1"],
			watergun: ["9L1"],
			waterpulse: ["9L1"],
			waterfall: ["9L1"],
			whirlpool: ["9L1"],
		},
	},
	gospiel: {
		learnset: {
			afteryou: ["9L1"],
			allyswitch: ["9L1"],
			bubble: ["9L1"],
			calmmind: ["9L1"],
			confusion: ["9L1"],
			cosmicpower: ["9L1"],
			dazzlinggleam: ["9L1"],
			ember: ["9L1"],
			followme: ["9L1"],
			futuresight: ["9L1"],
			gravity: ["9L1"],
			growl: ["9L1"],
			guardsplit: ["9L1"],
			healingwish: ["9L1"],
			hypervoice: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			lunardance: ["9L1"],
			magicroom: ["9L1"],
			mirrorcoat: ["9L1"],
			moonblast: ["9L1"],
			moonlight: ["9L1"],
			morningsun: ["9L1"],
			mysticalfire: ["9L1"],
			nightshade: ["9L1"],
			ominouswind: ["9L1"],
			petaldance: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			psybeam: ["9L1"],
			psychoshift: ["9L1"],
			psychic: ["9L1"],
			psychicnoise: ["9L1"],
			psyshock: ["9L1"],
			psywave: ["9L1"],
			shadowball: ["9L1"],
			storedpower: ["9L1"],
			swift: ["9L1"],
			synchronoise: ["9L1"],
			tackle: ["9L1"],
			teleport: ["9L1"],
			triattack: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			wish: ["9L1"],
			wonderroom: ["9L1"],
		},
	},
	rusalvia: {
		learnset: {
			afteryou: ["9L1"],
			alluringvoice: ["9L1"],
			allyswitch: ["9L1"],
			bubble: ["9L1"],
			calmmind: ["9L1"],
			confusion: ["9L1"],
			cosmicpower: ["9L1"],
			dazzlinggleam: ["9L1"],
			ember: ["9L1"],
			flipturn: ["9L1"],
			followme: ["9L1"],
			futuresight: ["9L1"],
			gravity: ["9L1"],
			growl: ["9L1"],
			guardsplit: ["9L1"],
			healingwish: ["9L1"],
			hydropump: ["9L1"],
			hypervoice: ["9L1"],
			icebeam: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			lunardance: ["9L1"],
			magicroom: ["9L1"],
			mirrorcoat: ["9L1"],
			moonblast: ["9L1"],
			moonlight: ["9L1"],
			morningsun: ["9L1"],
			mysticalfire: ["9L1"],
			nightshade: ["9L1"],
			ominouswind: ["9L1"],
			petaldance: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			psybeam: ["9L1"],
			psychic: ["9L1"],
			psychicnoise: ["9L1"],
			psychoshift: ["9L1"],
			psyshock: ["9L1"],
			psywave: ["9L1"],
			raindance: ["9L1"],
			shadowball: ["9L1"],
			storedpower: ["9L1"],
			surf: ["9L1"],
			swift: ["9L1"],
			synchronoise: ["9L1"],
			tackle: ["9L1"],
			teleport: ["9L1"],
			triattack: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			wish: ["9L1"],
			wonderroom: ["9L1"],
		},
	},
	seraphexe: {
		learnset: {
			afteryou: ["9L1"],
			allyswitch: ["9L1"],
			bubble: ["9L1"],
			calmmind: ["9L1"],
			confusion: ["9L1"],
			cosmicpower: ["9L1"],
			dazzlinggleam: ["9L1"],
			disable: ["9L1"],
			ember: ["9L1"],
			encore: ["9L1"],
			fierydance: ["9L1"],
			fireblast: ["9L1"],
			flamethrower: ["9L1"],
			followme: ["9L1"],
			futuresight: ["9L1"],
			gravity: ["9L1"],
			growl: ["9L1"],
			guardsplit: ["9L1"],
			healingwish: ["9L1"],
			heartswap: ["9L1"],
			hypervoice: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			lunardance: ["9L1"],
			magicroom: ["9L1"],
			mirrorcoat: ["9L1"],
			moonblast: ["9L1"],
			moonlight: ["9L1"],
			morningsun: ["9L1"],
			mysticalfire: ["9L1"],
			nightshade: ["9L1"],
			ominouswind: ["9L1"],
			petaldance: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			psybeam: ["9L1"],
			psychic: ["9L1"],
			psychicnoise: ["9L1"],
			psychoshift: ["9L1"],
			psyshock: ["9L1"],
			psywave: ["9L1"],
			shadowball: ["9L1"],
			storedpower: ["9L1"],
			swift: ["9L1"],
			synchronoise: ["9L1"],
			tackle: ["9L1"],
			teleport: ["9L1"],
			triattack: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			willowisp: ["9L1"],
			wish: ["9L1"],
			wonderroom: ["9L1"],
		},
	},
	mirrelette: {
		learnset: {
			allyswitch: ["9L1"],
			aurasphere: ["9L1"],
			aurorabeam: ["9L1"],
			auroraveil: ["9L1"],
			blizzard: ["9L1"],
			bodypress: ["9L1"],
			burningjealousy: ["9L1"],
			chillingwater: ["9L1"],
			confide: ["9L1"],
			craftyshield: ["9L1"],
			dazzlinggleam: ["9L1"],
			entrainment: ["9L1"],
			flash: ["9L1"],
			flashcannon: ["9L1"],
			foulplay: ["9L1"],
			freezedry: ["9L1"],
			gigadrain: ["9L1"],
			haze: ["9L1"],
			heartswap: ["9L1"],
			heavyslam: ["9L1"],
			icebeam: ["9L1"],
			iceshard: ["9L1"],
			icespinner: ["9L1"],
			iciclecrash: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			irondefense: ["9L1"],
			ironhead: ["9L1"],
			magiccoat: ["9L1"],
			magicroom: ["9L1"],
			metalsound: ["9L1"],
			mirrorcoat: ["9L1"],
			mirrorshot: ["9L1"],
			mist: ["9L1"],
			moonlight: ["9L1"],
			nightshade: ["9L1"],
			pound: ["9L1"],
			powdersnow: ["9L1"],
			powergem: ["9L1"],
			psychup: ["9L1"],
			reflecttype: ["9L1"],
			revelationray: ["9L1"],
			roleplay: ["9L1"],
			safeguard: ["9L1"],
			skillswap: ["9L1"],
			snatch: ["9L1"],
			snowscape: ["9L1"],
			steelbeam: ["9L1"],
			trick: ["9L1"],
			weatherball: ["9L1"],
			wonderroom: ["9L1"],
		},
	},
	klefkimccallister: {
		learnset: {
			astonish: ["9L1"],
			calmmind: ["9L1"],
			dazzlinggleam: ["9L1"],
			drainingkiss: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			fairylock: ["9L1"],
			fairywind: ["9L1"],
			flashcannon: ["9L1"],
			foulplay: ["9L1"],
			gigaimpact: ["9L1"],
			hyperbeam: ["9L1"],
			imprison: ["9L1"],
			irondefense: ["9L1"],
			lastresort: ["9L1"],
			lightscreen: ["9L1"],
			magicroom: ["9L1"],
			magnetrise: ["9L1"],
			metalsound: ["9L1"],
			mistyterrain: ["9L1"],
			playrough: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			psychic: ["9L1"],
			psyshock: ["9L1"],
			raindance: ["9L1"],
			recycle: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			sandstorm: ["9L1"],
			skittersmack: ["9L1"],
			sleeptalk: ["9L1"],
			spikes: ["9L1"],
			steelbeam: ["9L1"],
			storedpower: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swift: ["9L1"],
			switcheroo: ["9L1"],
			tackle: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			thunderwave: ["9L1"],
			torment: ["9L1"],
			trickroom: ["9L1"],
			flamethrower: ["9L1"],
			flameblast: ["9L1"],
			overheat: ["9L1"],
			pursuit: ["9L1"],
			flamecharge: ["9L1"],
			willowisp: ["9L1"],
			burningbulwark: ["9L1"],
			craftyshield: ["9L1"],
			painsplit: ["9L1"],
			taunt: ["9L1"],
		},
	},
	sacchamorte: {
		learnset: {
			umbralscythe: ["9L1"],
			acidarmor: ["9L1"],
			acidspray: ["9L1"],
			aquacutter: ["9L1"],
			aquaring: ["9L1"],
			astonish: ["9L1"],
			bite: ["9L1"],
			bodyslam: ["9L1"],
			brutalswing: ["9L1"],
			confuseray: ["9L1"],
			cosmicpower: ["9L1"],
			crosspoison: ["9L1"],
			curse: ["9L1"],
			darkpulse: ["9L1"],
			destinybond: ["9L1"],
			disable: ["9L1"],
			doubleedge: ["9L1"],
			dreameater: ["9L1"],
			embargo: ["9L1"],
			grudge: ["9L1"],
			gunkshot: ["9L1"],
			hex: ["9L1"],
			imprison: ["9L1"],
			lifedew: ["9L1"],
			lunge: ["9L1"],
			meanlook: ["9L1"],
			nightshade: ["9L1"],
			nightmare: ["9L1"],
			painsplit: ["9L1"],
			partingshot: ["9L1"],
			phantomforce: ["9L1"],
			poisongas: ["9L1"],
			poisonjab: ["9L1"],
			psychic: ["9L1"],
			pursuit: ["9L1"],
			shadowclaw: ["9L1"],
			shadowsneak: ["9L1"],
			signalbeam: ["9L1"],
			skittersmack: ["9L1"],
			sludgebomb: ["9L1"],
			sludgewave: ["9L1"],
			snarl: ["9L1"],
			spite: ["9L1"],
			stealthrock: ["9L1"],
			submission: ["9L1"],
			suckerpunch: ["9L1"],
			swordsdance: ["9L1"],
			sweetkiss: ["9L1"],
			sweetscent: ["9L1"],
			taunt: ["9L1"],
			teeterdance: ["9L1"],
			throatchop: ["9L1"],
			toxicspikes: ["9L1"],
			torment: ["9L1"],
			venomdrench: ["9L1"],
			wildcharge: ["9L1"],
			wish: ["9L1"],
		},
	},
	treench: {
		learnset: {
			darkestlatiat: ["9L1"],
			throatchop: ["9L1"],
			leafblade: ["9L1"],
			woodhammer: ["9L1"],
			suckerpunch: ["9L1"],
			spiritbreak: ["9L1"],
			drainpunch: ["9L1"],
			icepunch: ["9L1"],
			poisonjab: ["9L1"],
			nastyplot: ["9L1"],
			spikes: ["9L1"],
			taunt: ["9L1"],
			thunderwave: ["9L1"],
			spikyshield: ["9L1"],
			recycle: ["9L1"],
			energyball: ["9L1"],
			darkpulse: ["9L1"],
			icebeam: ["9L1"],
			flamethrower: ["9L1"],
			sludgebomb: ["9L1"],
			gigadrain: ["9L1"],
			megadrain: ["9L1"],
			absorb: ["9L1"],
			seedbomb: ["9L1"],
			grassknot: ["9L1"],
			acrobatics: ["9L1"],
			lashout: ["9L1"],
			leafstorm: ["9L1"],
			lowkick: ["9L1"],
			trailblaze: ["9L1"],
			assurance: ["9L1"],
			brutalswing: ["9L1"],
			bulletseed: ["9L1"],
			vinewhip: ["9L1"],
			ingrain: ["9L1"],
			dig: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			solarbeam: ["9L1"],
			solarblade: ["9L1"],
			magicalleaf: ["9L1"],
			leer: ["9L1"],
			megakick: ["9L1"],
			payback: ["9L1"],
			scaryface: ["9L1"],
			tackle: ["9L1"],
			snarl: ["9L1"],
			snowscape: ["9L1"],
			swagger: ["9L1"],
			powdersnow: ["9L1"],
			swift: ["9L1"],
			thief: ["9L1"],
			protect: ["9L1"],
			endure: ["9L1"],
			substitute: ["9L1"],
			rest: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			facade: ["9L1"],
			attract: ["9L1"],
			gigaimpact: ["9L1"],
			hyperbeam: ["9L1"],
			fling: ["9L1"],
			focusenergy: ["9L1"],
			uproar: ["9L1"],
			agility: ["9L1"],
			psychup: ["9L1"],
			workup: ["9L1"],
			weatherball: ["9L1"],
			helpinghand: ["9L1"],
		},
	},
	grincheartcaged: {
		learnset: {
			dazzlinggleam: ["9L1"],
			alluringvoice: ["9L1"],
			expandingforce: ["9L1"],
			storedpower: ["9L1"],
			steelbeam: ["9L1"],
			flashcannon: ["9L1"],
			focusblast: ["9L1"],
			aurasphere: ["9L1"],
			vacuumwave: ["9L1"],
			spiritbreak: ["9L1"],
			playrough: ["9L1"],
			ironhead: ["9L1"],
			hardpress: ["9L1"],
			closecombat: ["9L1"],
			superpower: ["9L1"],
			sacredsword: ["9L1"],
			seismictoss: ["9L1"],
			drainpunch: ["9L1"],
			brickbreak: ["9L1"],
			upperhand: ["9L1"],
			heartstamp: ["9L1"],
			xscissor: ["9L1"],
			slash: ["9L1"],
			furycutter: ["9L1"],
			cut: ["9L1"],
			growth: ["9L1"],
			heartswap: ["9L1"],
			takeheart: ["9L1"],
			bulkup: ["9L1"],
			charm: ["9L1"],
			irondefense: ["9L1"],
		},
	},
	lelitoccia: {
		learnset: {
			diracsea: ["9L1"],
			afteryou: ["9L1"],
			airslash: ["9L1"],
			allyswitch: ["9L1"],
			ancientpower: ["9L1"],
			astonish: ["9L1"],
			block: ["9L1"],
			confuseray: ["9L1"],
			curse: ["9L1"],
			darkpulse: ["9L1"],
			destinybond: ["9L1"],
			detect: ["9L1"],
			disable: ["9L1"],
			dreameater: ["9L1"],
			embargo: ["9L1"],
			extrasensory: ["9L1"],
			flash: ["9L1"],
			flashcannon: ["9L1"],
			foresight: ["9L1"],
			futuresight: ["9L1"],
			gigadrain: ["9L1"],
			gravity: ["9L1"],
			grudge: ["9L1"],
			guardswap: ["9L1"],
			healblock: ["9L1"],
			hex: ["9L1"],
			icebeam: ["9L1"],
			icywind: ["9L1"],
			imprison: ["9L1"],
			laserfocus: ["9L1"],
			leer: ["9L1"],
			magiccoat: ["9L1"],
			magicroom: ["9L1"],
			memento: ["9L1"],
			meteorbeam: ["9L1"],
			miracleeye: ["9L1"],
			moonlight: ["9L1"],
			nightshade: ["9L1"],
			nightmare: ["9L1"],
			ominouswind: ["9L1"],
			painsplit: ["9L1"],
			phantomforce: ["9L1"],
			powergem: ["9L1"],
			powerswap: ["9L1"],
			powertrick: ["9L1"],
			pound: ["9L1"],
			psychic: ["9L1"],
			psychicterrain: ["9L1"],
			psyshock: ["9L1"],
			punishment: ["9L1"],
			rockblast: ["9L1"],
			rockpolish: ["9L1"],
			rockslide: ["9L1"],
			rockthrow: ["9L1"],
			roleplay: ["9L1"],
			sandstorm: ["9L1"],
			shadowball: ["9L1"],
			shadowsneak: ["9L1"],
			skillswap: ["9L1"],
			smackdown: ["9L1"],
			spite: ["9L1"],
			stealthrock: ["9L1"],
			stoneedge: ["9L1"],
			taunt: ["9L1"],
			telekinesis: ["9L1"],
			teleport: ["9L1"],
			trick: ["9L1"],
			trickroom: ["9L1"],
			wonderroom: ["9L1"],
		},
	},
	deckherd: {
		learnset: {
			makeitrain: ["9L1"],
			flashcannon: ["9L1"],
			darkpulse: ["9L1"],
			baddybad: ["9L1"],
			hypervoice: ["9L1"],
			snarl: ["9L1"],
			payday: ["9L1"],
			payback: ["9L1"],
			bodyslam: ["9L1"],
			doubleedge: ["9L1"],
			megakick: ["9L1"],
			takedown: ["9L1"],
			lastresort: ["9L1"],
			headbutt: ["9L1"],
			doublehit: ["9L1"],
			covet: ["9L1"],
			ironhead: ["9L1"],
			bite: ["9L1"],
			crunch: ["9L1"],
			suckerpunch: ["9L1"],
			foulplay: ["9L1"],
			beatup: ["9L1"],
			fling: ["9L1"],
			thief: ["9L1"],
			doublekick: ["9L1"],
			wildcharge: ["9L1"],
			zenheadbutt: ["9L1"],
			bodypress: ["9L1"],
			defensecurl: ["9L1"],
			growl: ["9L1"],
			swagger: ["9L1"],
			flatter: ["9L1"],
			taunt: ["9L1"],
			agility: ["9L1"],
			cottonguard: ["9L1"],
			cottonspore: ["9L1"],
			partingshot: ["9L1"],
			switcheroo: ["9L1"],
			torment: ["9L1"],
			nastyplot: ["9L1"],
		},
	},
	caneine: {
		learnset: {
			playrough: ["9L1"],
			stoneswipe: ["9L1"],
			earthquake: ["9L1"],
			rollout: ["9L1"],
			metalclaw: ["9L1"],
			crushclaw: ["9L1"],
			bulldoze: ["9L1"],
			bodypress: ["9L1"],
			hornleech: ["9L1"],
			crunch: ["9L1"],
			icefang: ["9L1"],
			thunderfang: ["9L1"],
			jawlock: ["9L1"],
			uturn: ["9L1"],
			sugarrush: ["9L1"],
			painsplit: ["9L1"],
			stealthrock: ["9L1"],
			guardsplit: ["9L1"],
			curse: ["9L1"],
			rockpolish: ["9L1"],
			howl: ["9L1"],
			helpinghand: ["9L1"],
			roar: ["9L1"],
		},
	},
	picktreebel: {
		learnset: {
			acid: ["9L1"],
			acidspray: ["9L1"],
			bodyslam: ["9L1"],
			bugbite: ["9L1"],
			bulletseed: ["9L1"],
			clearsmog: ["9L1"],
			encore: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			gastroacid: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			grassknot: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			growth: ["9L1"],
			hyperbeam: ["9L1"],
			ingrain: ["9L1"],
			knockoff: ["9L1"],
			leafblade: ["9L1"],
			leafstorm: ["9L1"],
			leechlife: ["9L1"],
			lunge: ["9L1"],
			magicalleaf: ["9L1"],
			poisonjab: ["9L1"],
			poisonpowder: ["9L1"],
			pounce: ["9L1"],
			powerwhip: ["9L1"],
			protect: ["9L1"],
			razorleaf: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			scaryface: ["9L1"],
			seedbomb: ["9L1"],
			slam: ["9L1"],
			sleeppowder: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			sludgewave: ["9L1"],
			solarbeam: ["9L1"],
			spitup: ["9L1"],
			stockpile: ["9L1"],
			strengthsap: ["9L1"],
			stunspore: ["9L1"],
			substitute: ["9L1"],
			suckerpunch: ["9L1"],
			sunnyday: ["9L1"],
			swallow: ["9L1"],
			sweetscent: ["9L1"],
			swift: ["9L1"],
			swordsdance: ["9L1"],
			synthesis: ["9L1"],
			terablast: ["9L1"],
			thief: ["9L1"],
			tickle: ["9L1"],
			toxic: ["9L1"],
			trailblaze: ["9L1"],
			venoshock: ["9L1"],
			vinewhip: ["9L1"],
			weatherball: ["9L1"],
			worryseed: ["9L1"],
			wrap: ["9L1"],
			meteorbeam: ["9L1"],
			powergem: ["9L1"],
			ancientpower: ["9L1"],
			ivycudgel: ["9L1"],
			stoneedge: ["9L1"],
			rockslide: ["9L1"],
			rockblast: ["9L1"],
			accelerock: ["9L1"],
			rockpolish: ["9L1"],
			stealthrock: ["9L1"],
			sandstorm: ["9L1"],
		},
	},
	twinklingshade: {
		learnset: {
			airslash: ["9L1"],
			bounce: ["9L1"],
			darkpulse: ["9L1"],
			dualwingbeat: ["9L1"],
			foulplay: ["9L1"],
			hurricane: ["9L1"],
			knockoff: ["9L1"],
			snarl: ["9L1"],
			throatchop: ["9L1"],
			cosmicpower: ["9L1"],
			darkvoid: ["9L1"],
			defog: ["9L1"],
			disable: ["9L1"],
			encore: ["9L1"],
			followme: ["9L1"],
			haze: ["9L1"],
			healingwish: ["9L1"],
			helpinghand: ["9L1"],
			lunardance: ["9L1"],
			memento: ["9L1"],
			moonlight: ["9L1"],
			switcheroo: ["9L1"],
			tailwind: ["9L1"],
			teleport: ["9L1"],
			thunderwave: ["9L1"],
			wish: ["9L1"],
			dazzlinggleam: ["9L1"],
			extrasensory: ["9L1"],
			flashcannon: ["9L1"],
			icywind: ["9L1"],
			moonblast: ["9L1"],
			nightshade: ["9L1"],
			shadowball: ["9L1"],
			thunderbolt: ["9L1"],
			aircutter: ["9L1"],
			astonish: ["9L1"],
			brutalswing: ["9L1"],
			captivate: ["9L1"],
			confusion: ["9L1"],
			dreameater: ["9L1"],
			embargo: ["9L1"],
			fairywind: ["9L1"],
			feintattack: ["9L1"],
			flash: ["9L1"],
			fling: ["9L1"],
			fly: ["9L1"],
			grudge: ["9L1"],
			gust: ["9L1"],
			lashout: ["9L1"],
			lifedew: ["9L1"],
			lightscreen: ["9L1"],
			lunarblessing: ["9L1"],
			nightmare: ["9L1"],
			ominouswind: ["9L1"],
			payback: ["9L1"],
			psybeam: ["9L1"],
			psychoshift: ["9L1"],
			punishment: ["9L1"],
			razorwind: ["9L1"],
			roleplay: ["9L1"],
			screech: ["9L1"],
			sharpen: ["9L1"],
			snatch: ["9L1"],
			twister: ["9L1"],
			wingattack: ["9L1"],
		},
	},
	irontwilight: {
		learnset: {
			waningmoon: ["9L1"],
			psychic: ["9L1"],
			darkpulse: ["9L1"],
			moonblast: ["9L1"],
			thunderbolt: ["9L1"],
			icywind: ["9L1"],
			psyshock: ["9L1"],
			flashcannon: ["9L1"],
			focusblast: ["9L1"],
			aurasphere: ["9L1"],
			steelbeam: ["9L1"],
			lunardance: ["9L1"],
			calmmind: ["9L1"],
			guardsplit: ["9L1"],
			allyswitch: ["9L1"],
		},
	},
	faerwork: {
		learnset: {
			fireworkshot: ["9L1"],
			flamethrower: ["9L1"],
			fireblast: ["9L1"],
			dazzlinggleam: ["9L1"],
			shadowball: ["9L1"],
			powergem: ["9L1"],
			energyball: ["9L1"],
			nastyplot: ["9L1"],
			encore: ["9L1"],
			willowisp: ["9L1"],
			flareblitz: ["9L1"],
			flamecharge: ["9L1"],
			heatwave: ["9L1"],
			wildcharge: ["9L1"],
			drainingkiss: ["9L1"],
			hypervoice: ["9L1"],
			playrough: ["9L1"],
			trailblaze: ["9L1"],
			zenheadbutt: ["9L1"],
			mistyexplosion: ["9L1"],
			mistyterrain: ["9L1"],
			sunnyday: ["9L1"],
			snowscape: ["9L1"],
			safeguard: ["9L1"],
			solarbeam: ["9L1"],
			temperflare: ["9L1"],
			fairywind: ["9L1"],
			ember: ["9L1"],
			flash: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			swift: ["9L1"],
			protect: ["9L1"],
			endure: ["9L1"],
			substitute: ["9L1"],
			rest: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			facade: ["9L1"],
			attract: ["9L1"],
			gigaimpact: ["9L1"],
			hyperbeam: ["9L1"],
			fling: ["9L1"],
			focusenergy: ["9L1"],
			tackle: ["9L1"],
			uproar: ["9L1"],
			psychup: ["9L1"],
			workup: ["9L1"],
			celebrate: ["9L1"],
			present: ["9L1"],
			happyhour: ["9L1"],
		},
	},
	antaron: {
		learnset: {
			amnesia: ["9L1"],
			attract: ["9L1"],
			blizzard: ["9L1"],
			block: ["9L1"],
			breakingswipe: ["9L1"],
			bulldoze: ["9L1"],
			calmmind: ["9L1"],
			confide: ["9L1"],
			defog: ["9L1"],
			doubleteam: ["9L1"],
			dracometeor: ["9L1"],
			dragonbreath: ["9L1"],
			dragonclaw: ["9L1"],
			dragondance: ["9L1"],
			dragonpulse: ["9L1"],
			dragonrage: ["9L1"],
			dragonrush: ["9L1"],
			dragontail: ["9L1"],
			earthquake: ["9L1"],
			echoedvoice: ["9L1"],
			endeavor: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			extrasensory: ["9L1"],
			facade: ["9L1"],
			fireblast: ["9L1"],
			flamethrower: ["9L1"],
			fling: ["9L1"],
			fly: ["9L1"],
			focusblast: ["9L1"],
			frustration: ["9L1"],
			gigaimpact: ["9L1"],
			glare: ["9L1"],
			grassknot: ["9L1"],
			heatwave: ["9L1"],
			helpinghand: ["9L1"],
			hiddenpower: ["9L1"],
			hurricane: ["9L1"],
			hydropump: ["9L1"],
			hyperbeam: ["9L1"],
			hypervoice: ["9L1"],
			icebeam: ["9L1"],
			icywind: ["9L1"],
			lashout: ["9L1"],
			lightscreen: ["9L1"],
			mist: ["9L1"],
			naturalgift: ["9L1"],
			naturepower: ["9L1"],
			outrage: ["9L1"],
			playnice: ["9L1"],
			playrough: ["9L1"],
			protect: ["9L1"],
			psychup: ["9L1"],
			raindance: ["9L1"],
			razorwind: ["9L1"],
			rest: ["9L1"],
			return: ["9L1"],
			roar: ["9L1"],
			rockslide: ["9L1"],
			roost: ["9L1"],
			round: ["9L1"],
			safeguard: ["9L1"],
			scaleshot: ["9L1"],
			shadowball: ["9L1"],
			shadowclaw: ["9L1"],
			shockwave: ["9L1"],
			signalbeam: ["9L1"],
			sleeptalk: ["9L1"],
			snarl: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			steelwing: ["9L1"],
			stompingtantrum: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			superpower: ["9L1"],
			surf: ["9L1"],
			swift: ["9L1"],
			tailwind: ["9L1"],
			thunder: ["9L1"],
			thunderwave: ["9L1"],
			thunderbolt: ["9L1"],
			tickle: ["9L1"],
			toxic: ["9L1"],
			twister: ["9L1"],
			uproar: ["9L1"],
			waterpulse: ["9L1"],
			workup: ["9L1"],
			bodyslam: ["9L1"],
			draconicshuffle: ["9L1"],
			flamecharge: ["9L1"],
			torchsong: ["9L1"],
			airslash: ["9L1"],
			wish: ["9L1"],
		},
	},
	snowglob: {
		learnset: {
			icebeam: ["9L1"],
			blizzard: ["9L1"],
			grassknot: ["9L1"],
			icywind: ["9L1"],
			tailwind: ["9L1"],
			futuresight: ["9L1"],
			gigadrain: ["9L1"],
			protect: ["9L1"],
			helpinghand: ["9L1"],
			storedpower: ["9L1"],
			calmmind: ["9L1"],
			agility: ["9L1"],
			strengthsap: ["9L1"],
			recover: ["9L1"],
			rapidspin: ["9L1"],
			uturn: ["9L1"],
			stealthrock: ["9L1"],
		},
	},
	dinjingle: {
		learnset: {
			flashcannon: ["9L1"],
			alluringvoice: ["9L1"],
			moonblast: ["9L1"],
			voltswitch: ["9L1"],
			psychicnoise: ["9L1"],
			sparklingaria: ["9L1"],
			dazzlinggleam: ["9L1"],
			encore: ["9L1"],
			stealthrock: ["9L1"],
			healbell: ["9L1"],
			wish: ["9L1"],
			taunt: ["9L1"],
			ironhead: ["9L1"],
			spiritbreak: ["9L1"],
			wildcharge: ["9L1"],
			drainingkiss: ["9L1"],
			hypervoice: ["9L1"],
			playrough: ["9L1"],
			zenheadbutt: ["9L1"],
			mistyexplosion: ["9L1"],
			mistyterrain: ["9L1"],
			snowscape: ["9L1"],
			safeguard: ["9L1"],
			sonicboom: ["9L1"],
			metalsound: ["9L1"],
			irondefense: ["9L1"],
			heavyslam: ["9L1"],
			gyroball: ["9L1"],
			fairywind: ["9L1"],
			disarmingvoice: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			swift: ["9L1"],
			protect: ["9L1"],
			endure: ["9L1"],
			substitute: ["9L1"],
			rest: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			facade: ["9L1"],
			attract: ["9L1"],
			gigaimpact: ["9L1"],
			hyperbeam: ["9L1"],
			fling: ["9L1"],
			focusenergy: ["9L1"],
			tackle: ["9L1"],
			uproar: ["9L1"],
			psychup: ["9L1"],
			workup: ["9L1"],
			celebrate: ["9L1"],
			present: ["9L1"],
			happyhour: ["9L1"],
		},
	},
	guywithsweater: {
		learnset: {
			judgement: ["9L1"],
			doubleedge: ["9L1"],
			playrough: ["9L1"],
			spiritbreak: ["9L1"],
			flareblitz: ["9L1"],
			icespinner: ["9L1"],
			knockoff: ["9L1"],
			rapidspin: ["9L1"],
			moonblast: ["9L1"],
			dazzlinggleam: ["9L1"],
			wish: ["9L1"],
			drainingkiss: ["9L1"],
			hypervoice: ["9L1"],
			endeavor: ["9L1"],
			steelroller: ["9L1"],
			mistyexplosion: ["9L1"],
			mistyterrain: ["9L1"],
			snowscape: ["9L1"],
			safeguard: ["9L1"],
			fairywind: ["9L1"],
			disarmingvoice: ["9L1"],
			doubleslap: ["9L1"],
			headbutt: ["9L1"],
			pound: ["9L1"],
			retaliate: ["9L1"],
			charm: ["9L1"],
			confide: ["9L1"],
			swift: ["9L1"],
			protect: ["9L1"],
			endure: ["9L1"],
			substitute: ["9L1"],
			rest: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			facade: ["9L1"],
			bodyslam: ["9L1"],
			attract: ["9L1"],
			gigaimpact: ["9L1"],
			hyperbeam: ["9L1"],
			fling: ["9L1"],
			focusenergy: ["9L1"],
			tackle: ["9L1"],
			uproar: ["9L1"],
			psychup: ["9L1"],
			workup: ["9L1"],
			celebrate: ["9L1"],
			present: ["9L1"],
			happyhour: ["9L1"],
		},
	},
	gristletoe: {
		learnset: {
			sludgebomb: ["9L1"],
			sludgewave: ["9L1"],
			acid: ["9L1"],
			acidspray: ["9L1"],
			venoshock: ["9L1"],
			darkpulse: ["9L1"],
			energyball: ["9L1"],
			gigadrain: ["9L1"],
			megadrain: ["9L1"],
			absorb: ["9L1"],
			gunkshot: ["9L1"],
			poisonjab: ["9L1"],
			poisonfang: ["9L1"],
			crunch: ["9L1"],
			bite: ["9L1"],
			suckerpunch: ["9L1"],
			foulplay: ["9L1"],
			beatup: ["9L1"],
			powertrip: ["9L1"],
			knockoff: ["9L1"],
			lashout: ["9L1"],
			seedbomb: ["9L1"],
			bulletseed: ["9L1"],
			powerwhip: ["9L1"],
			pounce: ["9L1"],
			present: ["9L1"],
			toxic: ["9L1"],
			toxicspikes: ["9L1"],
			strengthsap: ["9L1"],
			nastyplot: ["9L1"],
			banefulbunker: ["9L1"],
			gastroacid: ["9L1"],
			torment: ["9L1"],
			encore: ["9L1"],
			charm: ["9L1"],
			tickle: ["9L1"],
			leer: ["9L1"],
			babydolleyes: ["9L1"],
			grassyterrain: ["9L1"],
		},
	},
	aegibashpolar: {
		learnset: {
			afteryou: ["9L1"],
			attract: ["9L1"],
			autotomize: ["9L1"],
			block: ["9L1"],
			brickbreak: ["9L1"],
			brutalswing: ["9L1"],
			closecombat: ["9L1"],
			confide: ["9L1"],
			doubleteam: ["9L1"],
			endure: ["9L1"],
			facade: ["9L1"],
			falseswipe: ["9L1"],
			flashcannon: ["9L1"],
			frustration: ["9L1"],
			gigaimpact: ["9L1"],
			gyroball: ["9L1"],
			headsmash: ["9L1"],
			hiddenpower: ["9L1"],
			hyperbeam: ["9L1"],
			irondefense: ["9L1"],
			ironhead: ["9L1"],
			kingsshield: ["9L1"],
			laserfocus: ["9L1"],
			magnetrise: ["9L1"],
			metalsound: ["9L1"],
			powertrick: ["9L1"],
			protect: ["9L1"],
			pursuit: ["9L1"],
			raindance: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			retaliate: ["9L1"],
			return: ["9L1"],
			reversal: ["9L1"],
			rockslide: ["9L1"],
			rocksmash: ["9L1"],
			round: ["9L1"],
			screech: ["9L1"],
			secretpower: ["9L1"],
			shockwave: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			steelbeam: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			swagger: ["9L1"],
			swordsdance: ["9L1"],
			tackle: ["9L1"],
			toxic: ["9L1"],
			wideguard: ["9L1"],
			triplestaffbash: ["9L1"],
			zapcannon: ["9L1"],
			thunder: ["9L1"],
			thunderbolt: ["9L1"],
			discharge: ["9L1"],
			voltswitch: ["9L1"],
			paraboliccharge: ["9L1"],
			chargebeam: ["9L1"],
			icebeam: ["9L1"],
			blizzard: ["9L1"],
			aurorabeam: ["9L1"],
			bodyslam: ["9L1"],
			magnetbomb: ["9L1"],
			wildcharge: ["9L1"],
			supercellslam: ["9L1"],
			spark: ["9L1"],
			icehammer: ["9L1"],
			iceshard: ["9L1"],
			thunderwave: ["9L1"],
			magneticflux: ["9L1"],
			electricterrain: ["9L1"],
			charge: ["9L1"],
			snowscape: ["9L1"],
			auroraveil: ["9L1"],
			mist: ["9L1"],
		},
	},
	gingermason: {
		learnset: {
			acidarmor: ["9L1"],
			alluringvoice: ["9L1"],
			aromaticmist: ["9L1"],
			attract: ["9L1"],
			blizzard: ["9L1"],
			brickbreak: ["9L1"],
			bulkup: ["9L1"],
			bulldoze: ["9L1"],
			bulletpunch: ["9L1"],
			burningjealousy: ["9L1"],
			circlethrow: ["9L1"],
			decorate: ["9L1"],
			dig: ["9L1"],
			drainpunch: ["9L1"],
			drainingkiss: ["9L1"],
			earthpower: ["9L1"],
			earthquake: ["9L1"],
			ember: ["9L1"],
			endeavor: ["9L1"],
			facade: ["9L1"],
			fireblast: ["9L1"],
			firepunch: ["9L1"],
			firespin: ["9L1"],
			flamecharge: ["9L1"],
			flamethrower: ["9L1"],
			flareblitz: ["9L1"],
			forcepalm: ["9L1"],
			gigaimpact: ["9L1"],
			heatcrash: ["9L1"],
			heatwave: ["9L1"],
			highhorsepower: ["9L1"],
			hyperbeam: ["9L1"],
			lick: ["9L1"],
			lowkick: ["9L1"],
			machpunch: ["9L1"],
			milkdrink: ["9L1"],
			mistyexplosion: ["9L1"],
			mistyterrain: ["9L1"],
			moonblast: ["9L1"],
			morningsun: ["9L1"],
			mudshot: ["9L1"],
			nastyplot: ["9L1"],
			overheat: ["9L1"],
			playrough: ["9L1"],
			powdersnow: ["9L1"],
			protect: ["9L1"],
			rest: ["9L1"],
			sandtomb: ["9L1"],
			scorchingsands: ["9L1"],
			sleeptalk: ["9L1"],
			sludgebomb: ["9L1"],
			snowscape: ["9L1"],
			solarbeam: ["9L1"],
			stealthrock: ["9L1"],
			stompingtantrum: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			superpower: ["9L1"],
			sweetscent: ["9L1"],
			taunt: ["9L1"],
			temperflare: ["9L1"],
			terablast: ["9L1"],
			toxic: ["9L1"],
			trailblaze: ["9L1"],
			willowisp: ["9L1"],
		},
	},
	swadloonfestive: {
		learnset: {
			batonpass: ["9L1"],
			bugbite: ["9L1"],
			bugbuzz: ["9L1"],
			charm: ["9L1"],
			electroweb: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			facade: ["9L1"],
			flail: ["9L1"],
			gigadrain: ["9L1"],
			grassknot: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			irondefense: ["9L1"],
			lightscreen: ["9L1"],
			lunge: ["9L1"],
			magicalleaf: ["9L1"],
			pounce: ["9L1"],
			protect: ["9L1"],
			raindance: ["9L1"],
			razorleaf: ["9L1"],
			rest: ["9L1"],
			screech: ["9L1"],
			seedbomb: ["9L1"],
			skittersmack: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			stickyweb: ["9L1"],
			stringshot: ["9L1"],
			strugglebug: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			switcheroo: ["9L1"],
			synthesis: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			trailblaze: ["9L1"],
			worryseed: ["9L1"],
			icebeam: ["9L1"],
			uturn: ["9L1"],
			icespinner: ["9L1"],
			wrap: ["9L1"],
			leechseed: ["9L1"],
			snowscape: ["9L1"],
		},
	},
	leavannyfestive: {
		learnset: {
			agility: ["9L1"],
			airslash: ["9L1"],
			batonpass: ["9L1"],
			bugbite: ["9L1"],
			bugbuzz: ["9L1"],
			bulletseed: ["9L1"],
			calmmind: ["9L1"],
			charm: ["9L1"],
			electroweb: ["9L1"],
			endure: ["9L1"],
			energyball: ["9L1"],
			entrainment: ["9L1"],
			facade: ["9L1"],
			falseswipe: ["9L1"],
			fellstinger: ["9L1"],
			flail: ["9L1"],
			gigadrain: ["9L1"],
			gigaimpact: ["9L1"],
			grassknot: ["9L1"],
			grassyglide: ["9L1"],
			grassyterrain: ["9L1"],
			helpinghand: ["9L1"],
			hyperbeam: ["9L1"],
			irondefense: ["9L1"],
			knockoff: ["9L1"],
			leafblade: ["9L1"],
			leafstorm: ["9L1"],
			lightscreen: ["9L1"],
			lowkick: ["9L1"],
			lunge: ["9L1"],
			magicalleaf: ["9L1"],
			poisonjab: ["9L1"],
			pollenpuff: ["9L1"],
			pounce: ["9L1"],
			protect: ["9L1"],
			raindance: ["9L1"],
			razorleaf: ["9L1"],
			reflect: ["9L1"],
			rest: ["9L1"],
			screech: ["9L1"],
			seedbomb: ["9L1"],
			shadowclaw: ["9L1"],
			skittersmack: ["9L1"],
			slash: ["9L1"],
			sleeptalk: ["9L1"],
			snore: ["9L1"],
			solarbeam: ["9L1"],
			stickyweb: ["9L1"],
			stringshot: ["9L1"],
			strugglebug: ["9L1"],
			substitute: ["9L1"],
			sunnyday: ["9L1"],
			switcheroo: ["9L1"],
			swordsdance: ["9L1"],
			synthesis: ["9L1"],
			tackle: ["9L1"],
			takedown: ["9L1"],
			terablast: ["9L1"],
			throatchop: ["9L1"],
			trailblaze: ["9L1"],
			tripleaxel: ["9L1"],
			worryseed: ["9L1"],
			xscissor: ["9L1"],
			holidaypreparation: ["9L1"],
			icespinner: ["9L1"],
			drillrun: ["9L1"],
			honeclaws: ["9L1"],
			snowscape: ["9L1"],
			sweetkiss: ["9L1"],
			wrap: ["9L1"],
		},
	},
	mausholddysfunctional: {
		learnset: {
			aerialace: ["9L1"],
			beatup: ["9L1"],
			bulletseed: ["9L1"],
			flamecharge: ["9L1"],
			lunge: ["9L1"],
			playrough: ["9L1"],
			populationbomb: ["9L1"],
			poweruppunch: ["9L1"],
			rockblast: ["9L1"],
			rocktomb: ["9L1"],
			trailblaze: ["9L1"],
			uturn: ["9L1"],
			chillingwater: ["9L1"],
			terablast: ["9L1"],
			protect: ["9L1"],
			substitute: ["9L1"],
			thunderwave: ["9L1"],
			tidyup: ["9L1"],
		},
	},
};
